
import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import _ from "lodash";

import { getImage } from "gatsby-plugin-image";
import { BgImage } from "gbimage-bridge"
import { Link } from "gatsby"
import { getEntityUrl } from "../../util";

import "./richtext.css";

import Menu from "./menu";
import EntityKeypad from "../../components/Keypad";

import Wrapper from "../../components/Wrapper";
import ComponentsWrapper from "../../components/ComponentsWrapper";

import List from "./list";

const PREFIX = 'EntityPage';

const classes = {
    root: `${PREFIX}-root`,
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
        padding: '0 10px 0 10px',
        textDecoration: 'none',
        fontFamily: 'scto, opensans, Verdana, Helvetica, Arial, sans-serif;',
    },

}));

const HeadlineDiv = styled('div')(({ theme }) => ({
  padding: "25px 10px",
  fontSize: "30px",
  lineHeight: "1",
  textTransform: "none",
  fontWeight: "bold",
  background: "#000",
  color: "#FFF!important",
  fontFamily:"frequenz",
  marginBottom: '18px',
}));

HeadlineDiv.defaultProps = {"data-id": "HeadlineDiv"};

const BildbuttonLink = styled(Link)(() => ({
    display: 'block',
    position: 'absolute',
    fontFamily: 'opensans, Verdana, Helvetica, Arial, sans-serif',
    fontStretch: 'normal',
    font: '1rem opensans, Verdana, Helvetica, Arial, sans-serif',
    /* font-family: 'openlight', */
    bottom: '12px',
    left: '10px',
    whiteSpace: 'nowrap',
    padding: '8px 15px',
    background: 'hsla(0, 0%, 0%, 0.27)',
    fontSize: 'var(--font-size-large)',
    color: '#ffffff!important',
    border: '1px solid #FFF',
    letterSpacing: '0.06em',
    textDecoration: 'none!important',
}));

const EntityPage = (props) => {
    const { entity, config, selectedModule, pageContext } = props;

    const { defaultLocale } = pageContext;

    const image = entity.largeImage ? getImage(entity.largeImage.localFile) : null;
    const headline = (entity.shortDesc || '').replace(/(?:\r\n|\r|\n)/g, '<br />');

    const [keypadShown, setKeypadShown] = useState(config?.showKeypadFirst || false);
    const keypadToggle = () => {
        setKeypadShown(!keypadShown);
    };

    return <Root className="kima">
        <Wrapper {...props} menu={Menu} title={entity.title} keypadSwitch={config?.showKeypad || false} keypadShown={keypadShown} onKeypad={keypadToggle}>
            {keypadShown ?
                <EntityKeypad {...{ entity }} {...props} /> :

                <div className={classes.root}>
                    {image !== null &&
                        <div style={{ width: '100%', height: '296px'}}>
                            <BgImage image={image} alt={headline} layout="fullWidth" style={{ width: '100%', height: '100%' }}>
                                {config.headerLink !== undefined && config.headerLink !== null &&
                                    <BildbuttonLink className={` ${classes.bildbutton}`}
                                        to={getEntityUrl({ entity: config.headerLink, defaultLocale })}>{config.headerLink.title}</BildbuttonLink>
                                }
                            </BgImage>
                        </div>
                    }
                    {headline?.length > 0 && <HeadlineDiv>{headline}</HeadlineDiv>}

                    <ComponentsWrapper {...props} defaultLocale={defaultLocale}/>

                    <List {...props} />
                </div>
            }
        </Wrapper>
    </Root>;
};

export default EntityPage;
